import {
  createApiAxios,
  getFabricAuthTokens,
  getFabricEndpoint,
} from '@/utilities/axios/api-axios';
import { getBaseURL, getDomain } from '@/utilities/getters/gameContextGetters';
import { CustomerDataEndpoint } from '../types';
import { AW_COOKIE } from '@/utilities/constants/metadata';
import config from '@/config';
import { useStore } from '@/store/useStore';
import { CustomerPreferences } from '@/store/slices/customerData/types';

const postCustomerPreferences = async (data: CustomerPreferences) => {
  const endpoint = getFabricEndpoint(
    'customerData',
    CustomerDataEndpoint.PREFERENCES,
  );
  const baseURL = getBaseURL();
  const { region, brand } = useStore.getState().runtime;

  try {
    const { authToken, loginToken } = await getFabricAuthTokens(
      'POST_CUSTOMER_PREFERENCES',
    );
    const requestData = {
      authToken,
      baseURL,
      params: {
        product: config.geoComply.product,
      },
      headers: {
        [AW_COOKIE.AUTH_TOKEN]: authToken,
        [AW_COOKIE.LOGIN_TOKEN]: loginToken,
        'x-base-domain': getDomain(),
        'x-region-code': region,
        'x-brand': brand,
      },
    };

    const instance = createApiAxios();
    return await instance.post(endpoint, data, requestData);
  } catch (error) {
    return error;
  }
};

export default postCustomerPreferences;
